import styled, { keyframes } from 'styled-components';

const Wrap = styled.div`
  display: block;
  width: min-content;
  margin: auto;

  ${({ css }) => css};
`;

const dotFlashing = keyframes`
  0% {
    background-color: #9880ff;
  }
  50%, 100% {
    background-color: rgba(152, 128, 255, 0.2);
  }
`;

const DotFlashing = styled.div`
  position: relative;
  width: 6px;
  height: 6px;
  border-radius: 5px;
  background-color: #9880ff;
  color: #9880ff;
  animation: ${dotFlashing} 1s infinite linear alternate;
  animation-delay: 0.5s;

  &::before,
  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
  }

  &::before {
    left: -15px;
    width: 6px;
    height: 6px;
    border-radius: 5px;
    background-color: #9880ff;
    color: #9880ff;
    animation: ${dotFlashing} 1s infinite alternate;
    animation-delay: 0s;
  }

  &::after {
    left: 15px;
    width: 6px;
    height: 6px;
    border-radius: 5px;
    background-color: #9880ff;
    color: #9880ff;
    animation: ${dotFlashing} 1s infinite alternate;
    animation-delay: 1s;
  }
`;

export { Wrap, DotFlashing };
